

















































































import ButtonMain from "@/common/components/atoms/ButtonMain.vue";
import IconBase from "@/common/components/atoms/IconBase.vue";
import IconArrowLeft from "@/common/components/icons/IconArrowLeft.vue";
import IconArrowRight from "@/common/components/icons/IconArrowRight.vue";
import commons from "@/common/store/modules/commons";

import { Prop, Component, Vue } from "vue-property-decorator";
import { mapState } from "vuex";

@Component({
  components: {
    ButtonMain,
    IconBase,
    IconArrowLeft,
    IconArrowRight
  },
  computed: {
    ...mapState({
      storeColorCode: () => commons.colorCode
    })
  }
})
export default class PageNavi extends Vue {
  @Prop({ type: Number, default: 1 }) currentPage!: number;
  @Prop({ type: Number, default: 1 }) maxPage!: number;
  @Prop({ type: [String, Boolean], required: true }) nextPageUrl!: string;
  @Prop({ type: [String, Boolean], required: true }) prevPageUrl!: string;
  @Prop({ type: String, required: true }) baseUrl!: string;
  @Prop({ type: String, default: "page" }) pageParam!: string;
  @Prop({ type: String }) search!: string;
  @Prop({ type: String }) ordering!: string;
  storeColorCode: string;

  buttonType = "";

  getCurrentColor(pageType: any) {
    const color = {
      disable: "#E2E2E2",
      active: "#9E9E9E"
    };

    return pageType === true ? color.disable : this.colorCode;
  }

  isPrevOrNextPageButton(buttonType = "prev") {
    const maxPage = this.maxPage;
    const currentPage = this.currentPage;

    const is = {
      firstPage: currentPage === 1,
      lastPage: currentPage === maxPage
    };

    const pageType = buttonType === "prev" ? is.firstPage : is.lastPage;
    const isPrevOrNextPageButton = pageType;

    return isPrevOrNextPageButton;
  }

  getPageNaviList() {
    const maxPage = this.maxPage;
    const arrayPosition = this.arrayPosition;

    const pagesArray = [...Array(maxPage).keys()].map((i) => ++i);

    const sliceArray = () => {
      const currentPosition = arrayPosition.currentPage;
      const is = {
        firstPage: currentPosition === 0,
        lastPageGroup: currentPosition >= arrayPosition.maxPage - 3,
        lastPage: currentPosition === arrayPosition.maxPage
      };
      let resultArray = [];

      if (is.firstPage) {
        if (maxPage > 4) {
          resultArray = pagesArray.slice(0, 2);
        } else {
          resultArray = pagesArray.slice(0, 4);
        }
      } else if (is.lastPage) {
        resultArray = pagesArray.slice(-4);
      } else if (is.lastPageGroup) {
        resultArray = pagesArray.slice(-4);
      } else {
        resultArray = pagesArray.slice(
          currentPosition - 1,
          currentPosition + 1
        );
      }

      return resultArray;
    };

    return sliceArray();
  }

  get isGroupBudget() {
    return commons?.userInfo.groupBudgetMode
  }

  get colorCode() {
    if(this.isGroupBudget) {
      return '#fc9014'
    }
    return this.storeColorCode
  }

  get currentPrevLinkColor() {
    return this.resultCurrentLinkColor("prev");
  }

  get currentNextLinkColor() {
    return this.resultCurrentLinkColor("next");
  }

  resultCurrentLinkColor(buttonType = "prev") {
    const isPrevOrNextPageButton = this.isPrevOrNextPageButton(buttonType);
    const currentLinkColor = this.getCurrentColor(isPrevOrNextPageButton);
    return currentLinkColor;
  }

  get prevButtonTag() {
    const isPrevOrNextPageButton = this.isPrevOrNextPageButton("prev");
    const tag = isPrevOrNextPageButton === true ? "span" : "a";
    return tag;
  }

  get nextButtonTag() {
    const isPrevOrNextPageButton = this.isPrevOrNextPageButton("next");
    const tag = isPrevOrNextPageButton === true ? "span" : "a";
    return tag;
  }

  get prevAndNextButtonTag() {
    const isPrevOrNextPageButton = this.isPrevOrNextPageButton();
    const tag = isPrevOrNextPageButton === true ? "span" : "a";
    return tag;
  }

  get pageNaviList() {
    return this.getPageNaviList();
  }

  get arrayPosition() {
    const maxPage = this.maxPage;
    const currentPage = this.currentPage;
    const arrayPosition = {
      currentPage: currentPage - 1,
      maxPage: maxPage - 1
    };

    return arrayPosition;
  }
  get searchParams() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const searchWordFromUrl = urlParams.get("search")
    ? (urlParams.get("search") as string)
    : ""
    return this.search ? `&search=${this.search}` : `&search=${searchWordFromUrl}`;
  }

  get orderingParam(){
    return this.ordering ? `&ordering=${this.ordering}` : ``;
  }
}
